<template>
  <div class="row mt-4" v-if="descuentos.length">
    <div class="col-12">
      <div class="card ficha-listado mb-4">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0 panel-section-title">Descuentos</h6>
              <p class="text-xs opacity-7 mb-0">Total: <b>{{ descFiltrados.length }}</b><span v-if="filtroEstado"> de {{ descuentos.length }}</span></p>
            </div>
          </div>

          <!-- Filtros de estado -->
          <div class="d-flex flex-wrap gap-2 mb-3">
            <button class="btn-filtro" :class="{ active: filtroEstado === null }" @click="filtroEstado = null">Todos</button>
            <button class="btn-filtro filtro-activo"      :class="{ active: filtroEstado === 'activo' }"      @click="filtroEstado = 'activo'">Activo</button>
            <button class="btn-filtro filtro-agotado"     :class="{ active: filtroEstado === 'agotado' }"     @click="filtroEstado = 'agotado'">Agotado</button>
            <button class="btn-filtro filtro-desactivado" :class="{ active: filtroEstado === 'desactivado' }" @click="filtroEstado = 'desactivado'">Desactivado</button>
          </div>

          <div class="table-responsive">
            <table class="table table-flush table-listado table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th :class="['th-sort', thSortClass('cupon')]" @click="sortBy('cupon')">Cupón / Rebajado</th>
                  <th :class="['th-sort', thSortClass('created_at')]" @click="sortBy('created_at')">Creado</th>
                  <th :class="['th-sort', 'text-center', thSortClass('usos_reales')]" @click="sortBy('usos_reales')">Usos (reales / límite)</th>
                  <th :class="['th-sort', 'text-center', thSortClass('estado')]" @click="sortBy('estado')">Estado</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="d in descPageRows" :key="d.descuento_id">
                  <td>
                    <div class="d-flex align-items-baseline gap-2">
                      <b>{{ d.cupon }}</b>
                      <span class="text-xs opacity-7">— {{ d.tipo === 'cupon' ? `${d.rebajado}%` : formatMoney(d.rebajado) }}</span>
                    </div>
                    <div v-if="d.producto_nombre" class="text-xs mt-1" :class="d.producto_eliminado ? 'producto-eliminado' : 'producto-activo'">
                      ({{ d.producto_nombre }})
                    </div>
                  </td>
                  <td class="text-xs opacity-7">{{ formatFecha(d.created_at) }}</td>
                  <td class="text-center"><b>{{ d.usos_reales ?? 0 }}</b> / {{ d.limite_usos ?? "∞" }}</td>
                  <td class="text-center">
                    <span class="badge-estado" :class="estadoBadge(d).cls">
                      {{ estadoBadge(d).label }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Paginación descuentos -->
          <div v-if="descTotalPages > 1" class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
            <p class="text-xs opacity-7 mb-0">{{ descFrom }}-{{ descTo }} de {{ descuentos.length }}</p>
            <div class="btn-group">
              <button class="btn btn-sm btn-pagi mb-0" :disabled="descPage <= 1" @click="descPage = 1">«</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="descPage <= 1" @click="descPage--">‹</button>
              <button class="btn btn-sm btn-pagi mb-0" disabled>{{ descPage }} / {{ descTotalPages }}</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="descPage >= descTotalPages" @click="descPage++">›</button>
              <button class="btn btn-sm btn-pagi mb-0" :disabled="descPage >= descTotalPages" @click="descPage = descTotalPages">»</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelTipsterDescuentos",
  props: {
    descuentos: { type: Array, default: () => [] },
  },
  data() {
    return {
      descPage: 1,
      descPerPage: 8,
      sortCol: 'created_at',
      sortDir: 'desc',
      filtroEstado: null,
    };
  },
  computed: {
    descFiltrados() {
      if (!this.filtroEstado) return this.descuentos;
      return this.descuentos.filter(d => this.estadoBadge(d).key === this.filtroEstado);
    },
    descSorted() {
      const arr = [...this.descFiltrados];
      if (!this.sortCol) return arr;
      const dir = this.sortDir === 'asc' ? 1 : -1;
      // Orden numérico del estado: activo=2, agotado=1, desactivado=0
      const estadoOrd = (d) => {
        if (d.producto_eliminado || !d.activo) return 0;
        if (d.limite_usos !== null && (d.usos_reales ?? 0) >= d.limite_usos) return 1;
        return 2;
      };
      return arr.sort((a, b) => {
        let va, vb;
        switch (this.sortCol) {
          case 'cupon':          va = (a.cupon || '').toLowerCase();          vb = (b.cupon || '').toLowerCase(); break;
          case 'producto_nombre': va = (a.producto_nombre || '').toLowerCase(); vb = (b.producto_nombre || '').toLowerCase(); break;
          case 'usos_reales':    va = a.usos_reales ?? 0;  vb = b.usos_reales ?? 0; break;
          case 'estado':         va = estadoOrd(a);         vb = estadoOrd(b);        break;
          case 'created_at':     va = a.created_at || '';   vb = b.created_at || '';  break;
          default: return 0;
        }
        if (va < vb) return -dir; if (va > vb) return dir; return 0;
      });
    },
    descTotalPages() { return Math.max(1, Math.ceil(this.descSorted.length / this.descPerPage)); },
    descPageRows() {
      const start = (this.descPage - 1) * this.descPerPage;
      return this.descSorted.slice(start, start + this.descPerPage);
    },
    descFrom() { return this.descSorted.length === 0 ? 0 : (this.descPage - 1) * this.descPerPage + 1; },
    descTo() { return Math.min(this.descPage * this.descPerPage, this.descSorted.length); },
  },
  watch: {
    descuentos()    { this.descPage = 1; },
    sortCol()       { this.descPage = 1; },
    filtroEstado()  { this.descPage = 1; },
  },
  methods: {
    estadoBadge(d) {
      if (d.producto_eliminado || !d.activo) return { key: 'desactivado', label: 'Desactivado', cls: 'badge-muted' };
      if (d.limite_usos !== null && (d.usos_reales ?? 0) >= d.limite_usos) return { key: 'agotado', label: 'Agotado', cls: 'badge-warn' };
      return { key: 'activo', label: 'Activo', cls: 'badge-ok' };
    },
    sortBy(col) {
      if (this.sortCol === col) { this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'; }
      else { this.sortCol = col; this.sortDir = ['cupon','producto_nombre'].includes(col) ? 'asc' : 'desc'; }
    },
    thSortClass(col) { return this.sortCol === col ? this.sortDir : ''; },
    formatFecha(f) {
      if (!f) return '—';
      const d = new Date(f);
      return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    formatMoney(n) {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
  },
};
</script>

<style scoped>
.th-sort { cursor: pointer; user-select: none; white-space: nowrap; }
.th-sort:hover { color: var(--q-gold); }

.table-empirulada { border-collapse: separate !important; border-spacing: 0 10px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 12px 14px; }
.table-empirulada tbody tr { background: var(--q-card); box-shadow: 0 6px 18px rgba(0,0,0,.06); }
.table-empirulada tbody td { border: 0 !important; padding: 12px 14px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
.table-empirulada tbody tr { overflow: hidden; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child {
  border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;
}
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.badge-estado {
  display: inline-block; padding: 3px 9px; border-radius: 20px;
  font-size: 11px; font-weight: 700; white-space: nowrap;
}
.badge-ok   { background: var(--q-green-soft); color: var(--q-green);          border: 1px solid var(--q-green); }
.badge-warn { background: rgba(255,165,0,.12);  color: #e8930a;                 border: 1px solid #e8930a; }
.badge-muted{ background: var(--q-hover);       color: var(--q-muted);          border: 1px solid var(--q-border-md); }

.producto-activo    { color: var(--q-green); font-weight: 600; }
.producto-eliminado { color: var(--q-red, #e74c3c); font-weight: 600; opacity: .85; }

.btn-filtro {
  padding: 4px 14px; border-radius: 20px;
  font-size: 12px; font-weight: 600; cursor: pointer; transition: .15s;
  border: 1px solid; opacity: .55;
}
.btn-filtro:hover                    { opacity: .85; }
.btn-filtro.active                   { opacity: 1; }

/* Todos — gris */
.btn-filtro:not([class*="filtro-"])               { background: var(--q-hover);      color: var(--q-muted); border-color: var(--q-border-md); }
/* Activo — verde */
.btn-filtro.filtro-activo            { background: var(--q-green-soft);  color: var(--q-green);  border-color: var(--q-green); }
/* Agotado — naranja/amarillo */
.btn-filtro.filtro-agotado           { background: rgba(255,165,0,.12);  color: #e8930a;         border-color: #e8930a; }
/* Desactivado — rojo */
.btn-filtro.filtro-desactivado       { background: rgba(231,76,60,.10);  color: #e74c3c;         border-color: #e74c3c; }

.btn-pagi {
  background: var(--q-card-alt); border: 1px solid var(--q-border-md);
  color: var(--q-muted); padding: 4px 10px; font-size: 0.8rem;
  transition: .15s;
}
.btn-pagi:hover:not(:disabled) { background: var(--q-hover); color: var(--q-gold); border-color: var(--q-gold); }
.btn-pagi:disabled { opacity: .4; cursor: not-allowed; }
</style>
